import { Controller } from 'react-hook-form';
import { DateInput3 } from '@blueprintjs/datetime2';
import { LoanQuoteDataFieldCommonProps } from './types';
import { LoanQuoteDataFormFieldPath } from '../QuoteDataFormSchema';
import { LoanQuoteDataBaseField } from './LoanQuoteBaseField';

function defaultFormatter(value: unknown) {
  const isValidDate = value && !isNaN(Date.parse(String(value)));

  return isValidDate ? new Date(String(value)).toLocaleDateString() : '-';
}

function getDateFormat() {
  const format = new Intl.DateTimeFormat(navigator.language).formatToParts(
    new Date(),
  );

  return format
    .map((part) => {
      switch (part.type) {
        case 'day':
          return 'dd';
        case 'month':
          return 'MM';
        case 'year':
          return 'yyyy';
        default:
          return part.value;
      }
    })
    .join('');
}

interface LoanQuoteDateFieldFieldProps extends LoanQuoteDataFieldCommonProps {
  name: LoanQuoteDataFormFieldPath;
  formatter?: (value: unknown) => string;
}

export const LoanQuoteDateField: React.FC<LoanQuoteDateFieldFieldProps> = ({
  name,
  formatter = defaultFormatter,
  ...props
}) => (
  <Controller
    name={name}
    render={({ field }) => (
      <LoanQuoteDataBaseField
        valueElement={formatter(field.value as never)}
        inputElement={
          <DateInput3
            onChange={(selectedDate) =>
              selectedDate
                ? field.onChange(new Date(selectedDate).toISOString())
                : null
            }
            minDate={new Date('1900-01-01')}
            maxDate={new Date('2099-12-31')}
            value={field.value ?? null}
            inputProps={{
              inputRef: field.ref,
              onBlur: field.onBlur,
              onChange: (e) => !e.target.value && field.onChange(null),
            }}
            dateFnsFormat={getDateFormat()}
          />
        }
        {...props}
      />
    )}
  />
);
